import { Button, Input, Label } from '@cibli/shared';
import { useTranslation } from 'react-i18next';

import { useSignIn } from '../hooks/useSignIn';

interface SignInFormProps {
  onSuccess: (data: {
    identifier: string;
    isEmail: boolean;
    hasExistingOTP?: boolean;
    timeLeft?: number;
  }) => void;
  onUserNotFound?: (identifier: string, isEmail: boolean) => void;
}

export default function SignInForm({ onSuccess, onUserNotFound }: SignInFormProps) {
  const { t } = useTranslation();
  const signIn = useSignIn({ onSuccess, onUserNotFound });

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-3">
        <h1 className="text-3xl md:text-4xl font-semibold">{t('dashboard.auth.signIn.title')}</h1>
        <p className="text-lg text-muted-foreground">{t('dashboard.auth.signIn.description')}</p>
      </div>

      <form onSubmit={signIn.handleSubmit} className="flex flex-col gap-5">
        <div className="flex flex-col gap-2">
          <Label htmlFor="identifier" className="text-base font-semibold">
            {t('dashboard.auth.signIn.identifierLabel')}
          </Label>
          <Input
            id="identifier"
            type="text"
            size="xl"
            value={signIn.identifier}
            onChange={e => signIn.setIdentifier(e.target.value)}
            placeholder={t('dashboard.auth.signIn.identifierPlaceholder')}
            disabled={signIn.isSubmitting}
            autoFocus
          />
          {signIn.error && <p className="text-sm text-destructive">{signIn.error}</p>}
        </div>

        <Button
          type="submit"
          className="w-full h-12 text-base"
          size="lg"
          disabled={signIn.isSubmitting}
        >
          {signIn.isSubmitting
            ? t('dashboard.auth.signIn.submittingButton')
            : t('dashboard.auth.signIn.submitButton')}
        </Button>
      </form>
    </div>
  );
}
